import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { hookTemplateSchema } from '../models/hookTemplate.schema';
import { hookTemplateQuerySchema } from './list.schema';

export type HookTemplateQuery = {
  ordering?: string;
} & PaginationQuery;

export const list = (query: HookTemplateQuery = {}) => {
  return {
    endpoint: '/hook_templates',
    method: 'GET',
    query: { ...query, includeTotal: true },
    querySchema: hookTemplateQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
    responseSchema: listResponse(hookTemplateSchema),
  } as const;
};
